export default __webpack_public_path__ + "img/168f99616877874a4b1695c7e4d6738e.png";